module.exports = "/images/arrow-down.svg?8372ce3721fa47e9fe923c132e5cb430";